module.exports = __webpack_public_path__ + "static/6-b0aef7b19656f1a32252416f1ca4b763.jpg";